"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthImpressions = void 0;
const health_impressions_data_1 = require("./data/health/health-impressions.data");
class HealthImpressions {
    getAll(data) {
        const output = [];
        const cashflowImpression = this.getScoreImpression(data.CashFlow, health_impressions_data_1.healthCashFlowImpressions.success, health_impressions_data_1.healthCashFlowImpressions.danger);
        const growthImpression = this.getScoreImpression(data.Growth, health_impressions_data_1.healthGrowthImpressions.success, health_impressions_data_1.healthGrowthImpressions.danger);
        const momentumImpression = this.getScoreImpression(data.Momentum, health_impressions_data_1.healthMomentumImpressons.success, health_impressions_data_1.healthMomentumImpressons.danger);
        const profitImpression = this.getScoreImpression(data.Profit, health_impressions_data_1.healthProfitImpressions.success, health_impressions_data_1.healthProfitImpressions.danger);
        const relativeValueImpression = this.getScoreImpression(data.RelativeValue, health_impressions_data_1.healthRelativeValueImpressions.success, health_impressions_data_1.healthRelativeValueImpressions.danger);
        [
            cashflowImpression,
            growthImpression,
            momentumImpression,
            profitImpression,
            relativeValueImpression,
        ].forEach((impression) => {
            if (impression) {
                output.push(impression);
            }
        });
        return output;
    }
    getScoreImpression(scoreData, successImpression, dangerImpression) {
        const { Actual: actual } = scoreData;
        if (actual >= 8) {
            return successImpression;
        }
        else if (actual < 4) {
            return dangerImpression;
        }
        return null;
    }
}
exports.HealthImpressions = HealthImpressions;
//# sourceMappingURL=health.impression.js.map